import * as types from './types'
import { createReducer } from 'app/state/utils'

export interface LoanMergesState {
  loanMerges: any[]
  isLoading: boolean
}

const initialState: LoanMergesState = { loanMerges: [], isLoading: false }

const loanMergesReducer = createReducer(initialState)({
  [types.GET_LOAN_MERGES]: (state: any, payload: any) => {
    return { ...state, loanMerges: payload.payload }
  },

  [types.EDIT_LOAN_MERGE]: (state: any, payload: any) => {
    const index = state.loanMerges.findIndex(
      (loanMerge: { id: any }) => loanMerge.id === payload.payload.data.id
    )
    const newArray = [...state.loanMerges]
    newArray[index] = { ...payload.payload.data, status: 'Draft' }
    return {
      ...state,
      loanMerges: newArray,
    }
  },

  [types.ADD_LOAN_MERGE]: (state: any, payload: any) => {
    return {
      ...state,
      loanMerges: [
        { ...payload.payload.data, status: 'Draft' },
        ...state.loanMerges,
      ],
    }
  },

  [types.SUBMIT_LOAN_MERGE]: (state: any, payload: any) => {
    const obj = state.loanMerges.find(
      (loanMerge: { id: any }) => loanMerge.id == payload.payload.id
    )
    if (obj) obj.status = 'Submitted'
    return {
      ...state,
      loanMerges: [...state.loanMerges],
    }
  },

  [types.APPROVE_LOAN_MERGE]: (state: any, payload: any) => {
    const index = state.loanMerges.findIndex(
      (loanMerge: { id: any }) => loanMerge.id == payload.payload.id
    )
    if (index >= 0) {
      state.loanMerges.splice(index, 1)
    }
    return {
      ...state,
      loanMerges: [...state.loanMerges],
    }
  },

  [types.REJECT_LOAN_MERGE]: (state: any, payload: any) => {
    const obj = state.loanMerges.find(
      (loanMerge: { id: any }) => loanMerge.id == payload.payload.id
    )
    if (obj) obj.status = 'Draft'
    return {
      ...state,
      loanMerges: [...state.loanMerges],
    }
  },

  [types.DELETE_LOAN_MERGE]: (state: any, payload: any) => {
    const index = state.loanMerges.findIndex(
      (loanMerge: { id: any }) => loanMerge.id == payload.payload.id
    )
    if (index >= 0) {
      state.loanMerges.splice(index, 1)
    }
    return {
      ...state,
      loanMerges: [...state.loanMerges],
    }
  },
  [types.START_LOADING_LOAN_MERGE]: (state: any) => {
    return { ...state, isLoading: true }
  },
  [types.STOP_LOADING_LOAN_MERGE]: (state: any) => {
    return { ...state, isLoading: false }
  },
})

export default loanMergesReducer